import axios from "axios";
export const saveApp = data => {
  return axios.request({
    url: "/api/app/saveApp",
    method: "post",
    data
  });
};
export const updateApp = data => {
  return axios.request({
    url: "/api/app/updateApp",
    method: "post",
    data
  });
};
// 分页查询应用主体
export const queryApp = params => {
  return axios.request({
    url: "/api/gig/app/access/entities/page",
    method: "get",
    params
  });
};
// 添加应用访问主体
export const addApp = data => {
  return axios.request({
    // url: "/api/gig/app/access/entities/add",
    url: "/api/gig/app/access/entities/addAndRemove",
    method: "post",
    data
  });
};
// 全量查询应用访问主体
export const getAllEntities = params => {
  return axios.request({
    url: "/api/gig/app/access/entities/list",
    method: "get",
    params
  });
};
export const removeEntities = data => {
  return axios.request({
    url: "/api/gig/app/access/entities/remove",
    method: "post",
    data
  });
};
export const countChildUnits = data => {
  return axios.request({
    url: "/api/unit/countChildUnits",
    method: "get",
    data
  });
};
export default {
  saveApp,
  updateApp,
  queryApp,
  addApp,
  removeEntities,
  countChildUnits
};